import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import LensBoard from './components/LensBoard';
import FeedSection from './components/FeedSection';
import NetworkMap from './components/NetworkMap';
import DeepRead from './components/DeepRead';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans antialiased">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <LensBoard />
        <FeedSection />
        <NetworkMap />
        <DeepRead />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}